import React, { useState, KeyboardEvent } from 'react';
import { useSelector } from 'react-redux';
import { IconFilter, IconSearch } from '~/presentation/base/icons';
import { Container } from './styles/StyledSearchList';
import { makeReduxGetAllConsultant } from '~/main/factories/usecases/consultant/GetAllConsultant';
import Dropdown from '../drop-down';
import { translator } from '../i18n';
import { iStore } from '~/domain/interfaces/models';

interface SearchProps {
  name?: string;
  children: JSX.Element[] | JSX.Element;
  icon?: JSX.Element;
}

const SearchListConsultant: React.FC<SearchProps> = ({ children }) => {
  const [consultant, setConsultant] = useState('');

  const { orgId, role, orgUnitId, orgUnits } = useSelector(
    (store: iStore) => store.auth.selectUser,
  );

  const handleSubmit = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      const orgUnitsFormatted =
        (orgUnits?.map(item => item.id).filter(Boolean) as number[]) ?? [];

      makeReduxGetAllConsultant().getAll({
        pageSize: 9999,
        filter: {
          org: orgId,
          orgUnit:
            role === 'ORG' || role === 'PRO' ? orgUnitsFormatted : undefined,
          name: consultant,
          situation: ['ACTIVE', '2FAWAIT'],
        },
      });
    }
  };

  return (
    <Container onSubmit={() => handleSubmit}>
      <IconSearch id="btn_searchFilter" />
      <input
        id="input_search"
        placeholder={`${translator('Buscar por...')}`}
        value={consultant}
        onChange={e => setConsultant(e.target.value)}
        onKeyPressCapture={handleSubmit}
      />
      <Dropdown label="Filtros" icon={<IconFilter />}>
        {children}
      </Dropdown>
    </Container>
  );
};
export default SearchListConsultant;
